package app.smartcoding.realrate.presentation.util

import androidx.compose.runtime.Stable
import kotlin.math.absoluteValue
import kotlin.math.roundToLong

fun Long.formatNumberWithSpaces(): String {
    val str = toString()
    val isNegative = str.startsWith("-")
    val numberStr = if (isNegative) str.substring(1) else str

    val formatted = numberStr.reversed().chunked(3).joinToString(" ").reversed()
    return if (isNegative) "-$formatted" else formatted
}

@Stable
fun Double.formatNumber(rounding: Boolean = false): String = if (rounding) {
    roundToLong().formatNumberWithSpaces()
} else {
    val intPart = toLong()
    val fractionPart = ((this * 100).absoluteValue.toLong() % 100).takeIf { it != 0L }?.toString()?.padStart(2, '0')
    if (fractionPart == null) intPart.formatNumberWithSpaces() else "${intPart.formatNumberWithSpaces()}.$fractionPart"
}